module.exports = __webpack_public_path__ + "img/img42.b184f3a1.jpg";